export default __webpack_public_path__ + "static/media/opensans-italic-webfont.da828029.woff2";